import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import useTheme from "@mui/material/styles/useTheme";

import { asTitle } from "utils/Utils";

import { usePrincipal } from "authentication/AuthProvider";

import NotificationsMenu from "menu/NotificationsMenu";
import StatusIndicator from "menu/StatusIndicator";
import UserMenu from "menu/UserMenu";

import OrganisationSelector from "./OrganisationSelector";
import LanguageSelector from "./LanguageSelector";

type NavLinkStyleProps = {
	isActive: boolean;
	isPending: boolean;
};

const MenuBar: React.FC = () => {
	const { t } = useTranslation();
	const principal = usePrincipal();

	const theme = useTheme();

	const menuStyle = useCallback(
		(args: NavLinkStyleProps): React.CSSProperties => {
			return {
				fontFamily: "Baloo Da 2, Helvetica, Arial, sans-serif",
				textDecorationLine: args.isActive ? "underline" : "none",
				textDecorationColor: theme.palette.secondary.main,
				textDecorationThickness: "2px",
				textUnderlineOffset: "4px",
				color: "white",
				fontSize: "16px",
				fontWeight: "500",
				margin: theme.spacing(2),
				lineHeight: "24px"
			};
		},
		[]
	);

	return (
		<>
			<AppBar
				sx={{
					displayPrint: "none",
					zIndex: theme.zIndex.drawer + 1
				}}>
				<Toolbar>
					<OrganisationSelector />

					<Box sx={{ flexGrow: 1 }}>
						{principal?.isFullyAuthenticated() && (
							<>
								<NavLink to="/trajectories" style={menuStyle}>
									{asTitle(t("trajectory_other"))}
								</NavLink>
								<NavLink to="/extracts" style={menuStyle}>
									{asTitle(t("extract_other"))}
								</NavLink>
								<NavLink to="/blueprints" style={menuStyle}>
									{asTitle(t("blueprint_other"))}
								</NavLink>
								<NavLink to="/trash" style={menuStyle}>
									{asTitle(t("trash"))}
								</NavLink>
							</>
						)}
					</Box>

					<StatusIndicator />

					<LanguageSelector />

					{principal?.isFullyAuthenticated() && <NotificationsMenu />}
					{principal && <UserMenu />}
				</Toolbar>
			</AppBar>
			<Toolbar />
		</>
	);
};

export default MenuBar;
